<template>
  <div class="product">
    <div class="column-center">
      <h2>IT咨询</h2>
      <p>
        技术的演进永无止境，创新的洞见至关重要。一匠致力于为客户量身定制转型战略，针对客户当前所面临的业务难题提供最适用的技术解决方案。
      </p>
      <p>一匠技术咨询服务借助领先技术、设计思维和敏捷方法帮助企业实现业务转型，以最适用于客户持续为既有系统提供澎湃动力。
      </p>
      <div class="btn" @click="jumpPages('/m_itAdvisory')">免费咨询</div>
    </div>

    <img class='free-advisory' src="../../static/images/7mouth/mianfeizixun.png" />
      
    <div class="big-title mar">软件研发</div>
    <div class="reason">
      <div class="item" v-for="item in reasonList" :key="item.id">
        <img :src="item.img" />
        <h2>{{ item.title }}</h2>
        <p>
          {{ item.desc }}
        </p>
      </div>
    </div>
    <div class="column-center">
      <h2>FA融资</h2>
      <div class="fa-box">
        一匠推出FA融资服务，立足于产业，提供产业链价值资源，全方位帮助创业公司实现高速成长的重要一步，一匠将会在资源服务的基础上，帮助客户找到靠谱的投资人，为客户提供全方位，高效，专业的一站式融资服务。
         </div>
    </div>
     <!-- <div class="column-center">
      <img src="../../static/images/home/miandan.png" />
      <h2>免单营销节方案</h2>
      <p>
        城市免单，创造自己的专属营销解决方案,一匠与城市各大商家强强联合，一起全民狂欢。
      </p>
      <div class="btn" @click="jumpPages('freeMarket')">查看更多</div>
    </div> -->

  </div>
</template>
<script>
export default {
  data() {
    return {
      reasonList: [
        {
          id: 0,
          img: require("../../static/images/7mouth/wulianwang.png"),
          title: "物联网&智能软硬定制",
          desc:
            "逻辑思维智能软硬件定制开发已对接众多智能硬件设备项目，实时高效的信息数字化服务，包括农业、医疗、新能源、家居、共享、运动健康等方面。",
        },
        {
          id: 1,
          img: require("../../static/images/7mouth/APP.png"),
          title: "APP定制",
          desc:
            "专注高端app开发，高效的技术框架，流畅快速的网页体验，自主研发的代码积累，科学管理流程，4大服务保障体系，让您开发无忧。",
        },
        {
          id: 2,
          img: require("../../static/images/7mouth/web.png"),
          title: "Web系统定制",
          desc:
            "丰富的系统架构经验，提供高并发、高可靠性、安全性系统解决方案，助力众多企业解决系统瓶颈，快速抢占市场先机。",
        },
        {
          id: 3,
          img: require("../../static/images/7mouth/xiaochengxu.png"),
          title: "微信小程序定制",
          desc:
            "小程序跨平台的属性，使开发和维护成本更低，开发速度更快。无缝对接微信、APP。逻辑思维软件丰富的开发经验，快速打造企业专属小程序。",
        },
        {
          id: 4,
          img: require("../../static/images/7mouth/gongzhonghao.png"),
          title: "微信公众号定制",
          desc:
            "为企业、组织深度高端定制功能更齐全、更强大的公众号服务平台，协助企业打造高端品牌形象。更好的为用户服务，提升品牌价值。",
        },
        {
          id: 5,
          img: require("../../static/images/7mouth/qiye.png"),
          title: "企业系统定制",
          desc:
            "定制属于企业的个性化管理软件，解决销售无计划、进度无把控、客户无管理、信息无反馈、业绩无考核等问题。",
        }
      ],
    };
  },
  methods: {
    jumpPages(url) {
      this.$router.push(url);
    },
  },
};
</script>
<style lang="stylus" scoped>
.product {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #fff;

  .big-title {
    text-align: center;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    font-size: 0.38rem;
    font-weight: 800;
    color: #333333;
    line-height: 0.28rem;
  }

  .big-title.mar {
    margin: 0 0 0.33rem;
  }

  .free-advisory {
    position: relative;
    top: -0.65rem;
    z-index: 1;
  }

  .column-center {
    display: flex;
    flex-direction: column;
    align-items: center;
    // margin-top: 0.5rem;

    img {
      width: 4.32rem;
      height: 4.1rem;
    }

    h2 {
      margin: 0 0 0.36rem;
      font-size: 0.36rem;
      font-weight: bold;
      color: #333333;
      line-height: 0.56rem;
    }

    p {
      text-align: center;
      font-size: 0.28rem;
      font-weight: 400;
      color: #666666;
      line-height: 0.56rem;
      margin: 0 0.24rem 0.1rem;
    }
  }

  .fa-box {
    width: 93%;
    background: rgba(255, 192, 0, 0.1);
    box-shadow: 0px 2px 15px 0px rgba(69, 79, 107, 0.08);
    padding: 0.36rem 0.26rem;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 0.45rem;
  }

  .btn {
    line-height: 40px;
    text-align: center;
    width: 100px;
    height: 40px;
    background: #FFC000;
    border-radius: 4px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    cursor: pointer;
    margin-top: 0.48rem;
    z-index: 2;
  }

  .reason {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    align-items: center;

    .item {
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      width: 94%;
      background: #FFFFFF;
      box-shadow: 0px 5px 17px 3px rgba(185, 185, 185, 0.15);
      border-radius: 0.08rem;
      margin: 0 0 15px 0;
      padding: 20px 0;

      img {
        width: 40px;
        height: 40px;
      }

      h2 {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
        margin: 16px 0 0.16rem;
      }

      p {
        width: 86%;
        font-size: 0.28rem;
        font-family: Microsoft YaHei;
        font-weight: 300;
        color: #666666;
        line-height: 0.4rem;
        text-align: center;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mobile/HomeProduct.vue